<template>
    <div class="d-flex flex-nowrap py-2 mb-2">
        <div class="day-timeline-width"></div>
        <div class="w-100 position-relative timeline-header pb-3">
            <div
                v-for="(hour, index) in hourBlocks"
                :key="hour"
                class="position-absolute text-nowrap hour-center"
                :style="{
                    left: `${index * hourBlockWidth}px`
                }"
            >
                {{ hour }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: {
        getRangeBetweenBlock: {
            from: "rangeBetweenBlock"
        }
    },
    props: {
        hourBlocks: {
            type: Array,
            required: true
        }
    },
    computed: {
        hourBlockWidth() {
            return this.getRangeBetweenBlock() * 60;
        }
    }
};
</script>

<style scoped>
.timeline-header {
    font-size: 14px;
    font-weight: 700;
}

.hour-center {
    transform: translate(-50%);
}
</style>
